const CommercePage = () => {
  return <h1>Comercio</h1>;
};
export default CommercePage;
